import {Record, Map} from "immutable"
import {Person, JsonData as PersonJsonData, fromJs as personFromJs} from "./Person"

export enum Role {
    Company,
    Division
}

const roleStringToEnum = {
    "company": Role.Company,
    "division": Role.Division,
}

interface Properties {
    id: number
    login: string
    role: Role
    crmLogged: boolean
    confirmed: boolean
    crmSentMessage: boolean
    executor: Person
    chief: Person
    production: Person
}

export class User extends Record({
    id: undefined,
    login: undefined,
    role: undefined,
    crmLogged: undefined,
    confirmed: undefined,
    crmSentMessage: undefined,
    executor: undefined,
    chief: undefined,
    production: undefined,
}) implements Properties {
    id: number
    login: string
    role: Role
    crmLogged: boolean
    confirmed: boolean
    crmSentMessage: boolean
    executor: Person
    chief: Person
    production: Person

    constructor(values: Properties) {
        super(values)
    }

    isCompany = () => this.role === Role.Company
    /**
     * @deprecated
     */
    isDivision = () => this.role === Role.Division
}

export type JsonData =  {
    id: number
    login: string
    role: "company" | "company-target" | "division"
    crmLogged: boolean
    confirmed: boolean
    crmSentMessage: boolean
    executor: PersonJsonData
    chief?: PersonJsonData
    production?: PersonJsonData
}

export const fromJs = ({
    id,
    login,
    role,
    crmLogged,
    confirmed,
    crmSentMessage,
    executor,
    chief,
    production,
}: JsonData): User => {
    let data: Properties = {
        id,
        login,
        role: roleStringToEnum[role],
        crmLogged,
        confirmed,
        crmSentMessage,
        executor : new Person({
            id: 0,
            fullName: "",
            position: "Ответственный",
        }),
        chief: chief ? personFromJs(chief) : new Person({
            id: 0,
            fullName: "",
            position: "Руководитель службы управления персоналом организации",
        }),
        production: production ? personFromJs(production) : new Person({
            id: 0,
            fullName: "",
            position: "Руководитель организации",
        }),
    }

    return new User(data)
}

export type Users = Map<number, User>